import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { convertMoneyToNumber, formatAmountOnly } from '../../util/currency';
import { CurrencySymbol } from '../../components';
import { LINE_ITEM_VAT_TAX_ON_NOW_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemVatTaxOnNowFeeMaybe = props => {
  const { lineItems, isProvider, intl } = props;

  const lineItem = lineItems.find(
    item => item.code === LINE_ITEM_VAT_TAX_ON_NOW_FEE && !item.reversal
  );

  if (!isProvider || !lineItem?.lineTotal) {
    return null;
  }

  const amount = convertMoneyToNumber(lineItem.lineTotal);
  const formatted = formatAmountOnly(intl, amount, 2);
  const percentageRaw = lineItem?.percentage;
  const percentage = percentageRaw != null ? Math.abs(Number(percentageRaw)) : null;
  const percentageDisplay =
    percentage != null && !Number.isNaN(percentage) ? ` (${percentage}%)` : '';

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.vatTaxOnNowFee" values={{ percentageDisplay }} />
      </span>
      <span className={css.itemValue}>
        <CurrencySymbol size={16} />
        <span>&nbsp;{formatted}</span>
      </span>
    </div>
  );
};

LineItemVatTaxOnNowFeeMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemVatTaxOnNowFeeMaybe;
